import { Booking } from '../types';
import { format } from 'date-fns';

// Simulate email sending in frontend
export async function sendBookingConfirmation(booking: Booking): Promise<boolean> {
  try {
    // Format the email content (for logging purposes)
    const emailContent = `
      Booking Confirmation
      
      Order Details
      Order Number: ${booking.order_number}
      Product: ${booking.product.name}
      Price: $${booking.product.price.toFixed(2)}

      Installation Details
      Location: ${booking.installation_location}
      Address:
      ${booking.delivery_address?.street || 'No street provided'}
      ${booking.delivery_address?.city || 'No city provided'}, ${booking.delivery_address?.state || 'No state provided'} ${booking.delivery_address?.zipCode || 'No ZIP code provided'}

      Customer Information
      Name: ${booking.customer_name}
      Phone: ${booking.customer_phone}
      ${booking.customer_email ? `Email: ${booking.customer_email}` : ''}

      An agent will be contacting you soon to confirm your installation date.

      If you have any questions, please contact us at:
      Phone: 909‑990‑9090
      Email: vholicllc@gmail.com

      Vholic Appliances
      126 W 5th St
      Santa Ana, CA 92703
    `;

    // Log the email content (simulating email sending)
    console.log('Simulated email content:', emailContent);
    console.log('Email would be sent to:', booking.customer_email);

    // Simulate network delay
    await new Promise(resolve => setTimeout(resolve, 500));

    return true;
  } catch (error) {
    console.error('Error simulating email send:', error);
    return false;
  }
}